import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SEOHead from './SEOHead';
import AgentsShowcase from './ui/AgentsShowcase';
import { agents } from '../data/agentMeta';

const { FiArrowRight } = FiIcons;

const CapabilitiesPage = () => {
  // Structured data must only assert deliverable capabilities — planned agents
  // stay visible in the UI (with a "Planned" badge) but are excluded here.
  const deliverableAgents = agents.filter((a) => a.status !== 'planned');
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'ManuscriptSmith capabilities & AI agents',
    numberOfItems: deliverableAgents.length,
    itemListElement: deliverableAgents.map((a, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: a.name,
      description: a.tagline,
    })),
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-parchment-50 to-parchment-100">
      <SEOHead
        title="Capabilities & AI Agents | ManuscriptSmith"
        description="Browse every ManuscriptSmith AI agent — from Author Voice DNA and the writing engine to covers, marketing, and outreach. Filterable grid + table with full details for each capability."
        keywords="manuscriptsmith agents, ai writing capabilities, author voice dna, cover studio, book marketing agents"
        canonicalUrl="https://manuscriptsmith.com/capabilities"
        structuredData={structuredData}
      />
      <main>
        <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Every <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-500 to-secondary-500">agent</span>, in one place
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            ManuscriptSmith is a studio of focused AI agents — writing, analysis, covers, marketing and more.
            Search, filter by area, and click any agent for the full story.
          </p>
        </section>

        <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <AgentsShowcase />
        </section>

        <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
          <div className="bg-gradient-to-r from-primary-500 to-secondary-500 rounded-2xl p-10 text-center text-white shadow-xl">
            <h2 className="text-3xl font-bold mb-4">Put these agents to work on your book</h2>
            <p className="text-lg opacity-90 mb-8">Get started — see exactly which agents are in each plan on the pricing page.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/signup" className="inline-flex items-center justify-center px-8 py-4 bg-white text-primary-600 font-bold text-lg rounded-lg hover:bg-gray-50">
                Get started <SafeIcon icon={FiArrowRight} className="w-5 h-5 ml-2" />
              </Link>
              <Link to="/pricing" className="inline-flex items-center justify-center px-8 py-4 bg-white/15 border border-white/40 text-white font-semibold text-lg rounded-lg hover:bg-white/25">
                See plans & add-ons
              </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default CapabilitiesPage;
